import React from "react";
import AOS from "aos";
import "aos/dist/aos.css"
import Fairy from "../img/fairy.jpg";
import Vuvu from "../img/vuvu.jpg";
import Vroll from "../img/v-roll.jpg";

const Tools = () => {
    React.useEffect(() => { 
        AOS.init({
            duration: 2000,
        });
    },[]);

    return (
        <div className="main">
            <div className="tool">
                <div className="tool-block left img">
                    <img className="tool-img" data-aos="fade-up" src={Fairy} />
                </div>
                <div className="tool-block right">
                    <h3 className="tool-title">
                        施術に使うジェル<br/> 「フェアリー」について
                    </h3>
                    <img className="tool-img-resp" src={Fairy} />
                    <p className="tool-text">
                        経口摂取で免疫賦活剤として使われている有機ゲルマニウムが、ルルドの泉の約５倍濃度入っています。話題のプラチナナノコロイドを配合し、ゲルマニウムとの相乗効果が電子供給量を圧倒的に増やし、副交感神経系に優位に働きストレス解消効果が期待できます。
                    </p>
                    <h4 className="tool-subtitle">
                        その他の期待できる効果
                    </h4>
                    <p className="tool-list">
                        余分な水分、老廃物、溜まった脂肪の体外排出の促進
                    </p>
                    <p className="tool-list">
                        浮腫の改善、ダイエットや美容にも役立つ
                    </p>
                    <p className="tool-list">
                        痛みや疲れのもとになる乳酸を排泄したり、血行促進もするので、疲れや肩こり、腰痛などの解消が期待できる。
                    </p>
                    <p className="tool-text">
                        ＊「フェアリー」の成分には、医療用に使われているものを使用しているので、敏感肌や病気、妊婦等に使用しても、口に入っても全く問題ありません。またその他の療法や道具（温熱や超音波等）との併用もOKです。
                    </p>
                </div>
            </div>

            <div className="tool">
                <div className="tool-block left">
                    <h3 className="tool-title">
                        プラチナvuvuについて
                    </h3>
                    <img className="tool-img-resp" src={Vuvu} />
                    <p className="tool-text">
                        プラチナvuvuは、「プラチナコロイド」で作られています。<br/>
                        プラチナコロイドは、マイナス４０mVの電位を持ち、塗布することにより、「バリア機能の健全化」「皮膚のターンオーバー正常化」「皮膚の感覚を高める」働きをする物質です。
                    </p>
                    <p className="tool-text">
                        ここでは、簡単にフレーズだけ並べますので興味のある方は是非、<a href="https://www.vuvu.co.jp/" class="tool-link" target="_blank" rel="noreferrer">vuvuホームページ</a>を開いていただくか、当店主にお聞きください。
                    </p>
                    <p className="tool-list">
                        低下した電位を正常に戻す（正常な細胞は-３０〜-５０mV）
                    </p>
                    <p className="tool-list">
                        他に類を見ない連続する還元力
                    </p>
                    <p className="tool-list">
                        塗るだけで心までリラックスさせる効果
                    </p>
                    <p className="tool-list">
                        もちろん頭皮にも同じ効果が期待できます。
                    </p>
                    <p className="tool-text">
                        プラチナvuvuシリーズは、”美容成分を肌へ浸透させる”化粧品ではありません。肌につけている間ずっと、まるでイオン導入をしているかのように必要な電位と水分を、必要な場所に必要なだけ届け、バランスを整える、本来の肌状態に戻す「electrical potential cosmetics（電位コスメ）」になります。
                    </p>
                </div>
                <div className="tool-block right img">
                    <img className="tool-img" data-aos="fade-up" src={Vuvu} />
                </div>
            </div>

            <div className="tool">
                <div className="tool-block left img">
                    <img className="tool-img" data-aos="fade-up" src={Vroll} />
                </div>
                <div className="tool-block right">
                    <h3 className="tool-title">
                        EMS・ローラー「V-roll」について
                    </h3>
                    <img className="tool-img-resp" src={Vroll} />
                    <p className="tool-text">
                        美容器・医療器のパイオニアであり、トップアスリートのサポート実績もある伊藤超短波株式会社製「V-roll」。耐久性が高く、肌に優しく安心して使用することができます。
                    </p>
                    <h4 className="tool-subtitle">
                        ローラー初のステンレスヘッド搭載
                    </h4>
                    <p className="tool-text">
                        ローラー美容器として業界初のステンレスヘッド搭載機である「V-roll」は、ステンレス素材の特性により、安定したEMS波形を供給を可能にしました。<br/>
                        また、他社製プラスチックコーティングのものに見られる、コーティングの剥がれや熱を持ったりといったリスクもありません。<br/><br/>
                        １kHzの安定した中周波EMSエネルギーの供給は、従来の低周波によるピリピリとした痛みを伴うこともなく、心地のよい理想的な表情筋のエクササイズを実現します。<br/><br/>
                        ローラー自体にマッサージ効果があるので、頭皮ケアにもおすすめできます。
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Tools